'use strict';
import {getOrganization} from '../../app/model/reducers/state';
import {getId} from './ReduxUtils';


module.exports = function () {
  return {
    $get: [
      '$ngRedux',
      function ($ngRedux) {

        function orgIdValidation(Class) {
          Class.$doBeforeValidation(autoAddOrg);
        }

        function autoAddOrg(instance) {
          if (!instance.organization) {
            const organization = getOrganization($ngRedux.getState());
            if (getId(organization)) {
              instance.organization = organization;
            } else {
              throw new Error("OrgMixin failed to retrieve the currently selected organization ID");
            }
          }
        }

        return orgIdValidation;
      }]
  }
};



// WEBPACK FOOTER //
// ./src/js/core-utilities/domain/OrgMixin.js